import {
  CREATE_FOOD_TYPE_SUCCESS,
  CREATE_FOOD_TYPE_FAIL,
  RETRIEVE_FOOD_TYPE_SUCCESS,
  RETRIEVE_FOOD_TYPE_FAIL,
  UPDATE_FOOD_TYPE_SUCCESS,
  UPDATE_FOOD_TYPE_FAIL,
  DELETE_FOOD_TYPE_SUCCESS,
  DELETE_FOOD_TYPE_FAIL,
} from "../actions/types";

const initialState = [];

function Reducer(datas = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_FOOD_TYPE_SUCCESS:
      return [...datas, payload];

    case RETRIEVE_FOOD_TYPE_SUCCESS:
      return payload;

    case RETRIEVE_FOOD_TYPE_FAIL:
      return [...datas];

    case UPDATE_FOOD_TYPE_SUCCESS:
      return datas.map((data) => {
        if (data.uuid === payload.uuid) {
          return {
            ...datas,
            ...payload,
          };
        } else {
          return data;
        }
      });

    case DELETE_FOOD_TYPE_SUCCESS:
      return datas.filter(({ uuid }) => uuid !== payload.uuid);

    default:
      return datas;
  }
}

export default Reducer;
